import moment from 'moment-timezone';
import { pluralString } from './functions';

export const formatFromISO = (
  date: moment.MomentInput,
  format: string = 'DD MMM YYYY'
) => {
  if (!date) return;
  return moment(date).format(format);
};

export const convertTimeToUTC = (date: Date) => {
  if (isNaN(date.getTime())) return null;
  const tzText = Intl.DateTimeFormat().resolvedOptions().timeZone;
  console.log(tzText, 'tzText');

  if (tzText === 'Asia/Singapore') {
    return date.toISOString();
  } else {
    function getTimeZoneNumber(date: Date, timeZone: string) {
      const options = { timeZone, timeZoneName: 'short' } as any;
      const dateTimeFormat = new Intl.DateTimeFormat([], options);

      const [{ value: tzNumber }] = dateTimeFormat
        .formatToParts(date)
        .filter((part) => part.type === 'timeZoneName');
      return tzNumber.substring(4);
    }

    const tzSGNumber = 8;
    const differenceTimezoneCountInMilSeconds =
      (tzSGNumber - Number(getTimeZoneNumber(date, tzText))) * 60 * 60 * 1000;

    const newDate = new Date(
      date.getTime() - differenceTimezoneCountInMilSeconds
    );
    return newDate.toISOString();
  }
};

export const convertTimeToLocal = (date: Date | string) => {
  // if (isNaN(date?.getTime())) return null;
  return new Date(date);
};

export const mergeDateTime = (
  date: moment.Moment | string,
  time: moment.Moment | string
) => {
  return new Date(
    `${moment(date)?.format('YYYY/MM/DD')} ${moment(time)?.format('HH:mm:ss')}`
  );
};

/**
 * Converts a date of birth to age display string, showing months for ages under 1 year
 * @param dob Date of birth in string format
 * @returns Formatted age string (e.g. "2 years old" or "5 months old")
 */
export const convertDobToAge = (dob: string) => {
  if (!dob) return '0 years old';
  const todayDate = new Date();
  const dobDate = new Date(dob);

  let years = todayDate.getFullYear() - dobDate.getFullYear();
  // Check if birth month has passed in current year
  const monthDiff = todayDate.getMonth() - dobDate.getMonth();
  // Check if the specific day of birth has passed in current month
  const isDobUpcoming = todayDate.getDate() < dobDate.getDate();

  // Adjust age down by 1 year if birthday hasn't occurred this year
  if (monthDiff < 0 || (monthDiff === 0 && isDobUpcoming)) {
    years--;
  }

  // For ages less than 1 year, calculate and display months instead
  if (years < 1) {
    // Calculate total months between dates
    let months = (todayDate.getFullYear() - dobDate.getFullYear()) * 12;
    months += todayDate.getMonth() - dobDate.getMonth();

    // Adjust months down by 1 if day of month hasn't been reached
    if (isDobUpcoming) {
      months--;
    }

    return pluralString('month', months) + ' old';
  }

  return pluralString('year', years) + ' old';
};
